"use client"
import React, { useState } from "react";
import MaxCharacterField from "@/components/shared/MaxCharacterField";
import { Form } from "react-bootstrap";
import { Formik } from "formik";
import useApi from "@/components/api/useApi";
import { emitEvent } from "@/lib/events";
import DOMPurify from "dompurify";

const yup = require("yup");

const CommentField = ({ type, contentId, subContentId }) => {
  const api = useApi();
  const randomNumber = api.getRandomInt(10000, 99999);

  const registerComment = (values, setSubmitting) => {
    var payload = {
      comment: values.comment,
      type,
      contentId,
      subContentId,
      callback: success => {
        if (success) {
          setCommentSubmitted(true);
        } else {
          setSubmitting(false);
        }
      }
    };
    // console.log("registerComment", payload);
    emitEvent("add-comment", payload);
  };

  const [commentSubmitted, setCommentSubmitted] = useState(false);

  const schema = yup.object({
    comment: yup
      .string()
      .required()
      .min(1)
      .max(500)
  });

  var values = {
    comment: ""
  };

  if (commentSubmitted) {
    return (
      <div className="with-icon">
        <span className="material-icons">comment</span>
        <span>Your comment has been submitted for review.</span>
      </div>
    );
  } else {
    return (
      <div>
        <Formik
          initialValues={values}
          validationSchema={schema}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              registerComment(values, setSubmitting);
            }, 400);
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            isSubmitting,
            isValid,
            values,
            touched,
            errors,
            setFieldValue
          }) => (
            <Form
              className="no-style"
              id={`comment-form-${randomNumber}`}
              onSubmit={handleSubmit}
            >
              <div className="form-group" id="validationFormikDescription">
                <MaxCharacterField
                  title="Submit a comment"
                  as="textarea"
                  rows={4}
                  schema={schema}
                  value={values.comment}
                  fieldName="comment"
                  isInvalid={!!errors.comment && touched.comment}
                  placeholder="Enter comment here"
                  onChange={e => {
                    const cleanValue = DOMPurify.sanitize(e.target.value, {
                      ALLOWED_TAGS: []
                    });
                    setFieldValue("cinnebt", cleanValue);
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.comment}
                </Form.Control.Feedback>
              </div>
              <button
                form={`comment-form-${randomNumber}`}
                className="btn btn-primary"
                disabled={!isValid || isSubmitting}
                type="submit"
              >
                Add Comment
              </button>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
};
export default CommentField;
